export const cookies_string = 'RISKMANAGEMENTCLIENTGAMECOOKIE';
export const server_ip=''//'http://18.167.20.24'
